import {
  JOINTLIST} from 'actions/joint';
import {reducerPackage} from "../../utils";
//协同工单
export const jointList = reducerPackage(JOINTLIST);

